<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="detailsCompany"
      name="detailsCompany"
      iconName="mdi-eye"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="View Details"
      @click="viewCompanyDetails()"
    ></BaseActionsButton>
    <BaseActionsButton
      id="editCompany"
      name="editCompany"
      iconName="mdi-pencil"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="Edit Details"
      @click="editCompany()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    editCompany() {
      this.params.context.parentComponent.editCompany(this.params.data.id);
    },
    viewCompanyDetails() {
      this.params.context.parentComponent.viewCompanyDetails(
        this.params.data.id
      );
    },
  },
};
</script>

<style>
</style>